import React from 'react';
import { Link } from 'react-router-dom';
import TableLoader from './TableLoader';

const PrestServicosTable = ({ 
  prestadores, 
  loading
}) => {
  if (loading) {
    return <TableLoader />;
  }

  return (
    <div className="table-responsive">
      <table className="table align-items-center mb-0">
        <thead>
          <tr>
            <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Nome</th>
            <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Empresa</th>
            <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Telefone</th>
            <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Tipo Serviço</th>
            <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Ações</th>
          </tr>
        </thead>
        <tbody>
          {prestadores.map((prest) => (
            <tr key={prest.id}>
              <td className="text-xs mb-0">{prest.name}</td>
              <td className="text-xs mb-0">{prest.company}</td>
              <td className="text-xs mb-0">{prest.phone}</td>
              <td className="text-xs mb-0">{prest.serviceType}</td>
              <td className="text-xs font-weight-bold mb-0">
                <Link to={`/PrestServicos/Visualizar/${prest.id}`} title="Visualizar" className="me-3">
                  <i className="bi bi-eye text-info"></i>
                </Link>
                <Link to={`/PrestServicos/Editar/${prest.id}`} title="Editar" className="me-3">
                  <i className="bi bi-pencil-square text-primary"></i>
                </Link>
                <Link to={`/PrestServicos/Excluir/${prest.id}`} title="Excluir">
                  <i className="bi bi-trash text-danger"></i>
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PrestServicosTable; 